import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Pages/Home';
import About from './components/Pages/About';

import Contact from './components/Pages/Contact';
import Navbar from './components/inc/Navbar';
import Footer from './components/inc/Footer';
import Fluids from './components/Pages/Fluids';
import Printer from './components/Pages/Printer';
import Spareparts from './components/Pages/Spareparts';
import Machine from './components/Pages/Machine';
import Services from './components/Pages/Services';
import ProductInfo from "./components/Pages/productInfo/productInfo";
import AllProduct from "./components/Pages/allproduct/Allproduct.js";
import Signup from "./components/Pages/registration/Signup.js";
import Login from "./components/Pages/registration/Login.js";
import AdminDashboard from './components/Pages/Admin/AdminDashboard.js';
import AddProductPage from './components/Pages/Admin/AddProductPage.js';
import UpdateProductPage from './components/Pages/Admin/UpdateProductPage.js';
import MyState from './Context/myState.js';
import { ProtectedRouteForAdmin } from './protectedRoute/ProtectedRouteForAdmin';
import { Toaster } from 'react-hot-toast';
import CategoryPage from './components/Pages/category/CategoryPage.js';
import Topslider from './components/TopSlider/Topslider.js';

function App() {
  return (
   
    <MyState>

    <Router>
      <Topslider/>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products/fluids" element={<Fluids />} />
        <Route path="/products/printer" element={<Printer />} />
        <Route path="/products/spareparts" element={<Spareparts />} />
        <Route path="/products/machine" element={<Machine />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/productinfo/:id" element={<ProductInfo />} />
        <Route path="/allproduct" element={<AllProduct />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/allproduct" element={<AllProduct />} />
        <Route path="/admin-dashboard" element={<ProtectedRouteForAdmin>
          <AdminDashboard />
        </ProtectedRouteForAdmin>} />
        <Route path="/addproduct" element={
          <ProtectedRouteForAdmin>
            <AddProductPage />
          </ProtectedRouteForAdmin>
        } />

        <Route path="/updateproduct/:id" element={
      <ProtectedRouteForAdmin>
      <UpdateProductPage />
    </ProtectedRouteForAdmin>
      } />
          <Route path="/category/:categoryname" element={<CategoryPage/>} />
      </Routes>
      <Toaster/>
      <Footer/>
    </Router>
    </MyState>
  );
}

export default App;
